module.exports = __webpack_public_path__ + "static/media/location-pin-brand-refresh.8f19a921.svg";